
import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface DeviceInfo {
	isTouchDevice: boolean;
	supportsDragDrop: boolean;
	isMobileSafari: boolean;
}

@Injectable()
export class FeatureDetectionService {
	public deviceInfoObservable: ReplaySubject<DeviceInfo>;
	private userAgent: string;

	constructor() {
		this.deviceInfoObservable = new ReplaySubject<DeviceInfo>();

		this.userAgent = navigator.userAgent.toLowerCase();

		const deviceInfo: DeviceInfo = {isTouchDevice: true, supportsDragDrop: true, isMobileSafari: true};
		deviceInfo.isTouchDevice = this.isTouchDevice();
		deviceInfo.supportsDragDrop = this.supportsDragDrop();
		deviceInfo.isMobileSafari = this.isMobileSafari();

		this.deviceInfoObservable.next( deviceInfo );
	}

	private isTouchDevice(): boolean {
		const isWindowsMobile = this.userAgent.match(/windows\sphone/i) || this.userAgent.match(/iemobile/i);
		const isNokiaBrowser = this.userAgent.match(/nokiabrowser/i);
		const isMobileSafari = this.isMobileSafari();
		const isiOS = this.userAgent.match(/iphone|ipad|ipod/i) !== null;
		const isAndroid = this.userAgent.match(/android/i) !== null;
		return !!(isiOS || isAndroid || isWindowsMobile || isNokiaBrowser || isMobileSafari);
	}

	private isMobileSafari(): boolean {
		return !!this.userAgent.match(/mobile.*\ssafari/i);
	}

	private supportsDragDrop() {
		return ('draggable' in document.createElement('span'));
	}
}
